module.exports = {
  en: {
    path: 'en',
    localeCode: 'en-gb',
    locale: 'English',
    default: true
  },
  de: {
    path: 'de',
    localeCode: 'de-de',
    locale: 'Deutsch'
  },
  es: {
    path: 'es',
    localeCode: 'es-es',
    locale: 'Español'
  },
  fr: {
    path: 'fr',
    localeCode: 'fr-fr',
    locale: 'Français'
  },
  it: {
    path: 'it',
    localeCode: 'it-it',
    locale: 'Italiano'
  },
  pl: {
    path: 'pl',
    localeCode: 'pl-pl',
    locale: 'Polski'
  },
  pt: {
    path: 'pt',
    localeCode: 'pt-pt',
    locale: 'Português'
  },
  nl: {
    path: 'nl',
    localeCode: 'nl-nl',
    locale: 'Nederlands'
  },
  zh: {
    path: 'zh',
    localeCode: 'zh-cn',
    locale: '中文'
  },
};









